module.exports = __webpack_public_path__ + "img/Group 4165.577ff914.svg";